exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nb-excel-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block; }\n\n.nb-excel-wrapper input[type=file] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0; }\n", ""]);

// exports
